<template>
  <v-layout align-center justify-center wrap>
    <v-dialog persistent v-model="dialog" v-if="dialog" max-width="800px" scrollable>
      <user notBroadcast showClose :company="editedItem" @closeDialog="dialog=false"></user>
    </v-dialog>
  </v-layout>
</template>

<script>
  import User from './../details/CompanyUser'
  import socketCompanyUserDialog from '../../mixin/socketCompanyUserDialog'

  export default {
    name: 'PCompanyUserDialog',
    mixins: [socketCompanyUserDialog],
    components: {User},
    data () {
      return {
        dialog: false,
        editedItem: {},
        editedItemDB: {}
      }
    },
    methods: {
      close () {
        this.$emit('close')
        this.$socket.emit('leaveRoom', {room: `companies${this.$auth.user().company_id}_manage`, username: this.$auth.user().id_text})
        this.dialog = false
      },
      openDialog () {
        this.$store.commit('loader/change_dialog', true)
        this.$http.get(`api/companies/` + this.$auth.user().company_id).then(res => {
          Object.assign(this.editedItem, JSON.parse(JSON.stringify(res.body)))
          Object.assign(this.editedItemDB, JSON.parse(JSON.stringify(res.body)))
          this.$socket.emit('joinRoom', {room: `companies${this.$auth.user().company_id}_manage`, username: this.$auth.user().id_text, view: 4})
          this.dialog = true
          this.$store.commit('loader/change_dialog', false)
        },
        err => {
          if (err.body.message === 'actionDenied') {
            this.$store.commit('snackbar/change_values', {timeout: 12000, text: 'Apenas os administradores da empresa podem gerenciá-la.', color: 'warning', dialog: true})
          } else {
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível abrir os participantes da empresa, reporte o erro.', color: 'error', dialog: true})
            alert('Erro! Falha ao enviar a requisição.')
          }
          this.$store.commit('loader/change_dialog', false)
        })
      },
      destroy () {
        this.$socket.emit('leaveRoom', {room: `companies${this.$auth.user().company_id}_manage`, username: this.$auth.user().id_text})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PCompanyUserDialog.vue